// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"489":"bc43d467","579":"eac006c1","618":"7d837a39","909":"4c9dfb18"}[chunkId] + ".chunk.js";
};